import {
  Tab as MuiTab,
  styled,
  tabClasses,
} from '@mui/material';

export const Tab = styled(MuiTab)((props) => {
  const { theme: { palette: { primary, background } } } = props;
  return {
    color: primary.dark,
    background: '#e7e7e7',
    textTransform: 'none',
    opacity: 1,
    padding: '20px',
    marginBottom: '10px',
    borderRadius: '6px',
    minHeight: 0,
    [`&.${tabClasses.selected}`]: {
      color: primary.dark,
      background: background.paper,
      paddingBottom: '30px',
      marginBottom: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  }
});
